
/**
 * SystemMessageResourceBundleモジュール
 * @author nabla2.metamodel.generator
 */
export module SystemMessageResourceBundleEn {

  export const field_required = 'must not be blank'
  export const field_size_max = 'must be {max} or fewer characters'
  export const field_byte_size_max = 'must be {max} or fewer bytes'
  export const field_invalid_chars = 'contains some characters which are not permitted using in this system'
  export const format_email = 'malformed mail address'
  export const format_time = 'invalid time'
  export const format_date = 'invalid date'
  export const format_year_month = 'invalid month of year'
  export const format_alphanumeric = 'only alphabets and digits can be used'
  export const format_ascii_printable = 'only alphabets, digits and some symbols can be used'
  export const format_positive_integer = 'must be integer excluding zero'
  export const format_integer = 'must be integer including zero'
  export const format_code_type = 'invalid code type'
  export const format_code_value = 'invalid code value'
  export const format_ascii_printable_half_kana = 'only alphabets, digits, half-width kana and some symbols can be used'
  export const printing_stale_cache_entry = 'Current process cannot proceed because excel is not in its latest version. Please download excel again.'
  export const E_BLU_42510 = 'Please select {0}.'
  export const E_BLU_42519 = 'Unsaved data exists. Do you want to discard?'
  export const E_BLU_44002 = 'The nightly batch processing. Please try later.'
}


// WEBPACK FOOTER //
// ./src/messages-resource-module-en.ts